import { isEmpty } from "lodash";
import React, { useState } from "react";
import { AddTreeStructure, SliderPanel } from "../../../../components";
import { usCurrency } from "../../../../utils";
import SourceWiseSplitUpSliderPanel from "./SourceWiseSplitUpSliderPanel/SourceWiseSplitUpSliderPanel";

const SourceWiseSplitUp = ({
  calculateNetAmount,
  sourceSplit,
  sourceSplitData,
  loanData,
}) => {
  const [splitupOpen, setSplitupOpen] = useState(false);
  const totalRequestedAmount = usCurrency(calculateNetAmount());

  return (
    <div className="loan-page-scroll">
      <div className="mt-3 ml-3">
        <div className="ft-14 fw-500 mb-3">Source-wise SplitUp</div>
        <div className="distribution-card mb-2">
          <div className="row justify-content-space-between mt-20 plr-3">
            <p className="ft-14 fw-500 mb-0">Total Requested Amount</p>
            <p className="ft-14 fw-500 mb-0" style={{ marginRight: "6px" }}>
              {totalRequestedAmount}
            </p>
          </div>
          <div className="loan-line-separator" />
          <div
            style={{
              borderBottom: "0.5px dashed #BDBDBD",
              marginBottom: "15px",
            }}
          >
            <AddTreeStructure data={sourceSplit} />
          </div>
          <div
            className="ft-12 loan-link cursor-pointer"
            onClick={() => {
              setSplitupOpen(!splitupOpen);
            }}
          >
            View Source-wise Splitups
          </div>
        </div>
      </div>
      <SliderPanel
        isOpen={splitupOpen}
        size="75"
        onClose={() => setSplitupOpen(!splitupOpen)}
        showCancel={true}
        backdropClicked={() => {
          setSplitupOpen(!splitupOpen);
        }}
      >
        <SourceWiseSplitUpSliderPanel
          splitupOpen={splitupOpen}
          setSplitupOpen={setSplitupOpen}
          values={loanData}
          overnightDelivery={
            loanData.overnightDelivery ?? loanData.overnightDelivery
          }
          sourceSplit={sourceSplitData}
          totalRequestedAmount={totalRequestedAmount}
        />
      </SliderPanel>
    </div>
  );
};

export default SourceWiseSplitUp;
